import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import QRCode from 'qrcode';
import { Configurations } from '../../Utils/Configurations';
import './Modal-QRCode.scss';

const ModalQRCode = ({ isOpen, toggle, conteudo }) => {
    const configurations = new Configurations();

    const [qrCodeBase64, setQrCodeBase64] = useState(null);
    const [loadingQR, setLoadingQR] = useState(true);
    const [copiado, setCopiado] = useState(false);

    // A URL (string) é a dependência do efeito: o objeto `conteudo` chega com nova referência a cada render
    // do pai, o que regeraria o QR Code sem necessidade.
    const urlConteudo = conteudo ? `${configurations.hkWebClient}/conteudo/${conteudo.codigo}` : null;

    useEffect(() => {
        if (isOpen && urlConteudo) {
            setLoadingQR(true);
            setQrCodeBase64(null);

            QRCode.toDataURL(urlConteudo, { width: 300, margin: 1 })
                .then((dataUrl) => setQrCodeBase64(dataUrl))
                .finally(() => setLoadingQR(false));
        } else {
            setLoadingQR(true);
            setQrCodeBase64(null);
            setCopiado(false);
        }
    }, [isOpen, urlConteudo]);

    const copiarLink = () => {
        if (!conteudo) return;
        const el = document.createElement('textarea');
        el.value = urlConteudo;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        setCopiado(true);
        setTimeout(() => setCopiado(false), 2000);
    };

    const downloadQRCode = () => {
        if (!qrCodeBase64 || !conteudo) return;
        const link = document.createElement('a');
        link.href = qrCodeBase64;
        link.download = `qr-${conteudo.codigo || conteudo._id}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if (!conteudo) return null;

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="modal-qrcode">
            <ModalHeader toggle={toggle}>QR Code do Conteúdo</ModalHeader>
            <ModalBody className="text-center">
                <h5 className="font-weight-bold mb-4">{conteudo.titulo}</h5>

                <div className="qrcode-container mb-4 d-flex align-items-center justify-content-center" style={{ minHeight: '300px' }}>
                    {loadingQR ? (
                        <i className="fas fa-spinner fa-spin fa-3x text-primary"></i>
                    ) : qrCodeBase64 ? (
                        <img
                            src={qrCodeBase64.startsWith('data:') ? qrCodeBase64 : `data:image/png;base64,${qrCodeBase64}`}
                            alt="QR Code"
                            style={{ width: 300, height: 300, margin: '0 auto', display: 'block' }}
                        />
                    ) : (
                        <div className="alert alert-warning m-0">O QR Code ainda não foi gerado.</div>
                    )}
                </div>

                <div className="form-group mb-0 text-left">
                    <label className="small text-muted font-weight-bold">Link do conteúdo:</label>
                    <input type="text" className="form-control" readOnly value={urlConteudo} />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="outline-secondary" onClick={copiarLink}>
                    <i className={`fas ${copiado ? 'fa-check text-success' : 'fa-copy'} mr-2`}></i>
                    {copiado ? 'Copiado!' : 'Copiar Link'}
                </Button>
                <Button color="outline-primary" onClick={downloadQRCode} disabled={loadingQR || !qrCodeBase64}>
                    <i className="fas fa-download mr-2"></i>
                    Download PNG
                </Button>
                <Button color="secondary" onClick={toggle}>Fechar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalQRCode;
